import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'WebLinkCommonLinkTextNodeView',
  props: {
    displayName: {
      type: String as PropType<string>,
      default: '',
    },
    ext: {
      type: Object as PropType<Record<string, unknown>>,
      default: () => null,
    },
  },
  data(): {
    url: string
  } {
    return {
      url: '',
    };
  },
  created(): void {
    const { url } = this.ext;
    if (url) {
      this.url = url as string;
    } else {
      this.url = '';
    }
  },
  methods: {
    onTextNodeClick(): void {
      if (this.url) {
        window.open(this.url);
      }
    },
  },
});
